import { useEffect, useRef } from "react";
import {
  setBuildingFilters,
  setFeatureFilters,
  setMapTypeZooms,
  showRoomnames,
} from "../functions/filter.map.js";
import { CAMPUS_COLLECTION } from "../../../../reduxStore/actions/main.js";
import { map } from "./useMap.sideEffects.js";
import { filterHTMLBuildingMarkers } from "../functions/filters/filterHTMLBuildingMarkers.js";

/**
 * Ruft den MapFilter auf, wenn die Anzeige von Features geändert werden muss
 * z.B.: Etagenwechsel, ModeWechsel (Navigation, normale Mapansicht...)
 */
export default function useMapFilter({
  currentFloorIndex,
  currentMapPage,
  currentBoundBuildingId,
  target,
  currentFeature,
  mapLoaded,
  setCurrentFloorNumber,
  useFloorBounce,
  geoJSONsUpdate,
  forceFeatureFilterUpdate,
  show3DBuildings,
  showBuildingMarkers,
  allowBuildingMarkers,
  currentChildrenFeatures,
  mapStyle,
  setMapLoaded,
  currentCampusId,
  terminalIsIdle,
  setCurrentFloorIndex,
}) {
  const prevEtage = useRef(0);

  useEffect(() => {
    if (!mapLoaded) return;

    setMapTypeZooms(currentMapPage);
    // Filtern der Polygongebäude!
    // set3DViewOfPolygons(show3DBuildings);
    setBuildingFilters();
  }, [mapLoaded, show3DBuildings, currentMapPage]);

  // features filtern nach neuen zoomlevels/etagen
  useEffect(() => {
    if (!mapLoaded) return;
    const currentFloorLevel =
      CAMPUS_COLLECTION.getLevelByIndex(currentFloorIndex);
    try {
      setFeatureFilters({
        level: currentFloorLevel,
        currentPage: currentMapPage,
        currentBoundBuildingId: currentBoundBuildingId,
        target: target,
        currentFeature: currentFeature,
        setCurrentFloorNumber: setCurrentFloorNumber,
      });

      // Karte bouncen lassen beim wechsel der etagen, aber nicht während einer anderen animation
      if (useFloorBounce && !map.isMoving()) {
        bounceAnimation(prevEtage.current, currentFloorLevel);
      }

      // PrevState speichern um die bounce animation richtig zu machen
      prevEtage.current = currentFloorLevel;
    } catch (error) {
      console.log(error);
    }
  }, [
    mapLoaded,
    currentFloorIndex,
    currentMapPage,
    target,
    currentFeature,
    geoJSONsUpdate,
    forceFeatureFilterUpdate,
    currentCampusId,
  ]);

  useEffect(() => {
    if (!mapLoaded) return;

    try {
      const currentCampus = CAMPUS_COLLECTION.getCurrentCampus();
      showRoomnames(currentCampus.showRoomnames);
    } catch (e) {
      console.error("Error togglen von roomnames", e);
    }
  }, [currentCampusId, mapLoaded]);

  // Filtern der html buildingmarker
  // Das muss nausgeschmisse werde weil es jetzt das MapSDK machen tut.
  // useEffect(() => {
  //   if (!mapLoaded) return;

  //   filterHTMLBuildingMarkers(
  //     showBuildingMarkers,
  //     allowBuildingMarkers,
  //     currentChildrenFeatures
  //   );
  // }, [
  //   showBuildingMarkers,
  //   currentChildrenFeatures,
  //   mapLoaded,
  //   currentCampusId,
  //   terminalIsIdle,
  // ]);

  const initCurrentCampusId = useRef(true);

  // Campuswechsel
  useEffect(() => {
    if (!mapLoaded || initCurrentCampusId.current) {
      initCurrentCampusId.current = false;
      return;
    }
    if (currentFeature && currentCampusId === currentFeature.campusId) {
      setCurrentFloorIndex(
        CAMPUS_COLLECTION.getIndexFromLevel(currentFeature.level, false)
      );
    } else {
      // Setzt EG oder Etage 0 als anfangszustand
      // wenn map lädt oder man den Campus wechselt
      setCurrentFloorIndex(CAMPUS_COLLECTION.getIndexFromLevel(0, false));
    }
  }, [currentCampusId]);

  useEffect(() => {
    // todo: irgendwann noch einpacken um mapstyle ändern zu können
    return;
    if (mapLoaded) {
      // setMapStyle(mapStyle);
      setMapLoaded(false);
      // map.on("load", () => {
      //   console.log("style load");
      //   setFeatureFilters({
      //     level: CAMPUS[0].floors[currentFloorIndex].stockwerk,
      //     stockwerke: CAMPUS[0].floors,
      //     currentPage: currentPage,
      //     show3DBuilding: show3DBuilding,
      //     target: target,
      //     mapStyle: mapStyle,
      //   });
      // });
    }
  }, [mapStyle, mapLoaded]);
}
function bounceAnimation(prevEtage, etage) {
  let zoomIn = map.getZoom() + 0.04;
  let zoomOut = map.getZoom() - 0.04;

  if (prevEtage !== etage) {
    if (map.isMoving()) return;
    map.flyTo(
      {
        zoom: prevEtage > etage ? zoomIn : zoomOut,
        speed: 0.18,
        curve: 1,
        easing(t) {
          return Math.sin(t);
        },
      },
      true
    );
    map.once("moveend", () => {
      if (map.isMoving()) return;
      map.flyTo(
        {
          zoom: prevEtage > etage ? zoomOut : zoomIn,
          speed: 0.25,
          curve: 1,
          easing(t) {
            return Math.sin(t);
          },
        },
        true
      );
    });
  }
}
